module.exports = "/images/aerial-13.jpg";